import React, { useEffect } from "react";
import stylesPc from "./SelectTag.module.css";
import stylesSp from "./SelectTag_SP.module.css";
import styleIpad from "./SelectTag_IP.module.css";
import { IsDevice } from "../../components/function/useDeviceFlag";
import {
    FormControl,
    FilledInput,
    createStyles,
    makeStyles,
    createTheme,
    ThemeProvider,
    Button,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import { getTagList, createNewTag, ResetDuplicateError } from "../../common/video/VideoActions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../root/RootReducer";
import PuiTypography from "../../components/elements/PuiTypography";
import { useInitFlag } from "../../components/function/useInitFlag";
import PuiMessage from "../../components/widgets/PuiMessage";
import MoreIcon from "../../assets/icon/MoreIcon";
import { countCharLength } from "../../utils/ValidationUtils";
import { Close } from "@material-ui/icons";
import { t } from "i18next";

const useStyles = makeStyles(() =>
    createStyles({
        searchInput: {
            height: "100%",
            width: IsDevice("iphone") ? "250px" : "664px",
            color: "white",
            padding: "3px 0px 16px 10px",
            fontFamily: "Yu Gothic",
            fontSize: "18px",
            opacity: "0.8",
            borderRadius: "5px",
            backgroundColor: "#FFFFFF0D",
        },
        formControl: {
            boxSizing: "content-box",
            position: "relative",
            width: "664px",
            height: "50px",
            paddingBottom: "24px",
            marginBottom: "8px",
            zIndex: 20,
        },
    })
);

interface SelectTagProps {
    /* モーダル表示切り替え */
    in: boolean;
    // モーダル閉じる
    onClose?: () => void;
    tagList: string[];
    setTagList: (tagList: string[]) => void;
    setIsSaved?: (flg: boolean) => void;
}

const theme = createTheme({
    palette: {
        secondary: {
            main: "#606060",
        },
    },
});

const SelectTag = React.forwardRef<HTMLDivElement, SelectTagProps>(function SelectTag(props, ref) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    const { onClose, tagList, setTagList, setIsSaved } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [displaySkillTag, ChangeDisplaySkillTag] = React.useState<string[]>([]);
    const [searchSkill, ChangeSearchSkill] = React.useState<string[]>([]);
    const [isLimitTag, ChangeLimitTag] = React.useState(false);
    const [isLimitAddTag, ChangeLimitAddTag] = React.useState(false);
    const { tags, tagDuplicateError } = useSelector(({ video }: AppState) => video);
    const [newTag, setNewTag] = React.useState<string>("");
    const [newTagList, setNewTagList] = React.useState<string[]>(tagList);
    const [searchKey, setSearchKey] = React.useState("");
    const [isShowError, setShowError] = useInitFlag();
    const [openUploadMessage, setOpenUploadMessage] = React.useState(false);
    const [isAddTag, setIsAddTag] = useInitFlag(false);

    // タグフォームの入力値が変更されたら最初に検索 = onchange, onchange = handleConditionChangeと定義
    const handleConditionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log("handleConditionChange");
        // handleConditionChangeにeventが来たら関数
        // eventの型はReact.ChangeEvent<HTMLInputElement>
        setSearchKey(event.currentTarget.value.trim());
        const input = event.currentTarget.value.trim().split(/\s+/);
        if (input.length > 0 && input[0] !== "") {
            dispatch(getTagList(input));
            ChangeSearchSkill(input);
        } else {
            dispatch(getTagList([]));
            ChangeSearchSkill([]);
        }
        ChangeDisplaySkillTag([]);
    };

    const handleTagChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        //タグタイトル文字数チェック
        if (countCharLength(event.currentTarget.value) <= 40) {
            setNewTag(event.currentTarget.value);
            if (setIsSaved) {
                setIsSaved(false);
            }
        }
    };

    const handleTagKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (isAddTag && event.key === "Enter" && (newTag || searchKey)) {
            handleNewTag();
        }
    };

    const handleAddTag = () => {
        if (onClose) {
            setTagList(newTagList);
            if (setIsSaved) {
                setIsSaved(false);
            }
            onClose();
        }
    };

    const closeErrorMessage = () => {
        setShowError(false);
        dispatch(ResetDuplicateError());
    };

    const handleNewTag = () => {
        if (newTag !== "") {
            const input = newTag.trim().split(/\s+/);
            if (input.length > 0 && input[0] !== "") {
                dispatch(createNewTag(newTag, input));
                ChangeSearchSkill([]);
            }
            if (!newTagList.includes(newTag)) {
                setNewTagList([...newTagList, newTag]);
                console.log(newTagList);
            }
            if (setIsSaved) {
                setIsSaved(false);
            }
        }
    };

    const handleCheck = (tag: string) => {
        let tempList = newTagList;
        if (newTagList.includes(tag)) {
            tempList = newTagList.filter((v) => v !== tag);
        } else {
            tempList = newTagList.concat(tag);
        }
        setNewTagList(tempList);
    };

    useEffect(() => {
        if (tagDuplicateError !== "") {
            setShowError(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tagDuplicateError]);

    useEffect(() => {
        dispatch(getTagList([]));
    }, [dispatch]);

    // 検索していないときは、新規追加したタグを合わせて表示させる。検索時はフィルター結果を表示させる
    useEffect(() => {
        ChangeDisplaySkillTag([]);
        const tmpTags: string[] = [];
        tags &&
            tags.length > 0 &&
            tags.map((row) => {
                // タグ表示を重複しないように
                if (!tmpTags.includes(row.tag.title)) {
                    return tmpTags.push(row.tag.title);
                } else {
                    return "";
                }
            });
        if (searchSkill.length === 0) {
            ChangeDisplaySkillTag(tagList.concat(tmpTags.filter((tag) => !tagList.includes(tag))));
        } else {
            ChangeDisplaySkillTag(tmpTags);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tagList, tags]);

    // タグ数制限
    useEffect(() => {
        if (newTagList.length > 5) {
            ChangeLimitTag(true);
        } else {
            ChangeLimitTag(false);
        }
    }, [newTagList]);
    // 追加タグ数制限
    useEffect(() => {
        if (newTagList.length > 4) {
            ChangeLimitAddTag(true);
        } else {
            ChangeLimitAddTag(false);
        }
    }, [newTagList]);

    return (
        <>
            <ThemeProvider theme={theme}>
                {!IsDevice("desktop") && (
                    <div onClick={onClose} className={styles.closeButton}>
                        <img
                            src={require("../../assets/image/closeFilter.svg").default}
                            alt="close"
                        />
                    </div>
                )}
                <div className={styles.root}>
                    <div className={styles.conditionArea}>
                        <FormControl
                            fullWidth
                            variant="filled"
                            color="secondary"
                            className={classes.formControl}
                        >
                            <FilledInput
                                id="searchInput"
                                value={isAddTag ? newTag : searchKey}
                                disableUnderline
                                onChange={isAddTag ? handleTagChange : handleConditionChange}
                                placeholder={
                                    isAddTag
                                        ? String(t("追加するタグを入力してください"))
                                        : String(t("タグを検索"))
                                }
                                onKeyPress={handleTagKeyPress}
                                endAdornment={
                                    isAddTag ? (
                                        <div className={styles.addTagButton} onClick={handleNewTag}>
                                            {t("追加")}
                                        </div>
                                    ) : (
                                        <Search
                                            color="secondary"
                                            style={{
                                                color: "white",
                                                marginTop: "13px",
                                                marginRight: "12px",
                                            }}
                                        />
                                    )
                                }
                                className={classes.searchInput}
                            />

                            {isAddTag && (
                                <div className={styles.tagCounts}>{`${countCharLength(
                                    newTag
                                )}/40`}</div>
                            )}
                        </FormControl>

                        {isAddTag ? (
                            <div className={styles.closeBtn} onClick={() => setIsAddTag(false)}>
                                <Close />
                            </div>
                        ) : (
                            <div
                                className={`${styles.moreIcon} ${
                                    isLimitAddTag ? styles.isLimitAddTag : ""
                                }`}
                                onClick={() => setIsAddTag(true)}
                                onMouseEnter={() => setOpenUploadMessage(true)}
                                onMouseLeave={() => setOpenUploadMessage(false)}
                            >
                                <MoreIcon />
                            </div>
                        )}
                        {!isAddTag && openUploadMessage && (
                            <div
                                className={styles.hoverStatusButton}
                                // style={{ right: isAddTag ? "22px" : "-48px" }}
                            >
                                <PuiTypography color="white">
                                    {" "}
                                    {t("新規タグを追加します")}
                                </PuiTypography>
                            </div>
                        )}
                    </div>
                    <div className={styles.tagArea}>
                        {displaySkillTag.map((item) => (
                            <div
                                className={styles.tagCheckBox}
                                onClick={() => handleCheck(item)}
                                key={item}
                                style={{
                                    backgroundColor: newTagList.includes(item)
                                        ? "#333A43"
                                        : "#24282E",
                                }}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                    <div className={styles.btnArea}>
                        <div
                            style={{ display: isLimitTag ? "block" : "none" }}
                            className={styles.limitAttention}
                        >
                            <p
                                style={{
                                    color: "var(--studio-btn-bg)",
                                    fontSize: "15px",
                                }}
                            >
                                {t("※登録できるタグは5件までです")}
                            </p>
                        </div>
                        <div
                            className={`${styles.buttonGroup} ${
                                isLimitTag ? styles.isLimitTag : ""
                            }`}
                        >
                            <Button
                                type="submit"
                                onClick={handleAddTag}
                                color="secondary"
                                disabled={isLimitTag}
                                className={styles.addButton}
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    fontFamily: "noto-sans-cjk-jp,sans-serif",

                                    color: isLimitTag ? "var(--loading-bg)" : "white",
                                    backgroundColor: isLimitTag
                                        ? "var(--button-bg)"
                                        : "var(--studio-btn-bg)",
                                }}
                            >
                                {t("完了")}
                            </Button>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
            <PuiMessage
                open={isShowError}
                type="error"
                title={tagDuplicateError}
                duration={5000}
                onClose={closeErrorMessage}
            />
        </>
    );
});

export default SelectTag;
